<template>
  <div class="panoramic-info">
    <div class="info">
      <h4>全景点信息</h4>
      <p>
        <span>全景ID</span>{{handlePid}}
      </p>
      <p>
        <span>全景点总数</span>{{panoramasData?panoramasData.total_count:0}}
      </p>
      <p>
        <span>有效全景数</span>{{panoramasData?panoramasData.visible_count:0}}
      </p>
      <p>
        <span>隐藏全景数</span>{{panoramasData?panoramasData.total_count - panoramasData.visible_count:0}}
      </p>
    </div>
    <div class="control">
      <h4>全景校正</h4>
      <div class="control-slider">
        <div>x: </div>
        <el-slider v-model="x"
                   :min="-180"
                   :max="180"
                   @input="$emit('changeX',x * (Math.PI/180))">
        </el-slider>
      </div>
      <div class="control-slider">
        <div>y: </div>
        <el-slider v-model="y"
                   :min="-180"
                   :max="180"
                   @input="$emit('changeY',y * (Math.PI/180))">
        </el-slider>
      </div>
      <div class="control-slider">
        <div>z: </div>
        <el-slider v-model="z"
                   :min="-180"
                   :max="180"
                   @input="$emit('changeZ',z* (Math.PI/180))">
        </el-slider>
      </div>
      <el-button size="small" @click="reset">重置</el-button>
      <el-button size="small" @click="$emit('saveAdjust',x,y,z)">保存</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      x: 0,
      y: 0,
      z: 0,
    };
  },
  props: {
    handlePid: {
      type: Number,
    },
    panoramasData: {
      type: Object,
    },
  },
  methods: {
    reset() {
      this.$emit('resetSlider');
    },
  },
};
</script>
<style lang='less' scoped>
.panoramic-info{
background: #1b1b1b;
height: 100%;
margin-top: 50px;
padding: 0px 30px;
position: fixed;
right: 0;
top: 50px;
.info, .control{
  width: 200px;
  padding: 10px;
  background-color: rgb(50,50,52);
  border-radius: 8px;
  color: #fff;
  h4{
    font-size: 14px;
    margin: 0;
  }
  p{
    font-size: 12px;
    span{
      margin-right: 15px;
    }
  }
}
.control{
  margin-top: 30px;
  &-slider{
    display: flex;
    align-items: center;
    .el-slider{
      width: 95%;
      margin-left: 20px;
    }
    ::v-deep .el-slider__runway{
      width: 95%;
    }
  }
  ::v-deep button.el-button.el-button--default.el-button--small{
      color: #D8D8D8;
      border-color: #48484A;
      padding: 9px 28px;
      background-color: #48484A;
    }
  }
}
</style>
